export enum ApplicationUserType {
    Staff = 1,
    Attorney = 2
}
